import persist from './persist'
import axios from 'axios'
// import { NotUnique } from '../errors/bucketErrors'
// import { axapi } from '../helpers/axinstance'
// import router from '../router/index'

export default {
  state: {
    cloudTowers: [],
    cloudTowerPreviews: [],
    cloudTowerConfigs: [],
    downloadCombos: [
      {
        tower_height: 40,
        sm_height: 1,
        tower_distance: 3200,
      },
    ],
    towerHeights: [
      14, 17, 20, 23, 26, 30, 38, 46,
    ],
    smHeights: [1, 2, 3, 4],
  },
  mutations: {
    // Cloud Towers
    HEAT_UPDATE_CLOUD_TOWER (state, data) {
      // let previewExists = false;
      let previewIndex = -1
      state.cloudTowers.filter((preview, index) => {
        if (preview.rowkey === data.rowkey) {
          // previewExists = true;
          previewIndex = index
          state.cloudTowers[previewIndex] = data
        }
      })
    },
    HEAT_SAVE_CLOUD_TOWERS (state, data) {
      state.cloudTowers = data
    },
    HEAT_SAVE_CLOUD_TOWER_CONFIGS (state, data) {
      state.cloudTowerConfigs = data
    },

    // Cloud Tower Previews
    HEAT_UPDATE_CLOUD_TOWER_PREVIEW (state, data) {
      let previewExists = false
      let previewIndex = -1
      state.cloudTowerPreviews.filter((preview, index) => {
        if (preview.rowkey === data.rowkey && preview.tower_rowkey === data.tower_rowkey) {
          previewExists = true
          previewIndex = index
          state.cloudTowerPreviews[previewIndex].geojson = data.geojson
          state.cloudTowerPreviews[previewIndex].visible = data.visible
          state.cloudTowerPreviews[previewIndex].footprints = data.footprints
        }
      })
      if (!previewExists) {
        state.cloudTowerPreviews.push(data)
      }
    },
  },
  actions: {
    // Cloud Tower
    async getCloudTowers ({ state, commit, dispatch }) {
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/heat-tower`)
        console.log(data)

        commit('HEAT_SAVE_CLOUD_TOWERS', data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async createHeatTower ({ state, commit, dispatch }, payload) {
      var params = {
        ...payload,
      }
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/heat-tower`, params)
        console.log(data)
        return data
      } catch (error) {
        console.log(error)
        throw await dispatch('processAxiosError', error)
      }
    },
    async updateHeatTower ({ state, commit, dispatch }, payload) {
      var params = {
        ...payload,
      }
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/heat-tower/${payload.rowkey}`, params)
        console.log(data)
        await commit('HEAT_UPDATE_CLOUD_TOWER', data)

        return data
      } catch (error) {
        // console.log(error)
        throw await dispatch('processAxiosError', error)
      }
    },
    async deleteCloudTower ({ state, commit, dispatch }, payload) {
      var params = {
        endpoint: 'vw-heat',
        action: 'delete-heat-tower',
        ...payload,
      }
      try {
        const { data } = await axios.post('/api-map.php', params)
        console.log(data)
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        commit('SELECT_APPT_OPTS', [])
      }
    },
    heatUpdateCloudTowerVis ({ commit }, payload) {
      console.log(payload)
      commit('HEAT_UPDATE_CLOUD_TOWER', payload)
    },

    // Cloud Tower Props
    heatUpdateCloudTowerPreview ({ commit }, payload) {
      console.log(payload)
      commit('HEAT_UPDATE_CLOUD_TOWER_PREVIEW', payload)
    },

    // Cloud Tower Config
    async getCloudTowerConfigs ({ state, commit, dispatch }) {
      console.log('Retrieving Heat Tower configs...')
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/heat-tower-config`)
        await commit('HEAT_SAVE_CLOUD_TOWER_CONFIGS', data)
        console.log(`Retrieved Heat Tower configs! Count: ${data.length}`)

        return data
      } catch (error) {
        console.log('Error retrieving Heat Tower configs')
        await dispatch('processAxiosError', error)
        await commit('HEAT_SAVE_CLOUD_TOWER_CONFIGS', [])
        console.log(error)
        return []
      }
    },
    async getCloudTowerConfig ({ state, commit, dispatch }, payload) {
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/heat-tower-config/${payload}`)
        // commit('HEAT_SAVE_CLOUD_TOWERS', data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async createCloudTowerConfig ({ state, commit, dispatch }, payload) {
      var params = {
        endpoint: 'vw-heat',
        action: 'create-heat-tower-config',
        ...payload,
      }
      try {
        const { data } = await axios.post('/api-map.php', params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        alert('error :(')
      }
    },
    async updateCloudTowerConfig ({ state, commit, dispatch }, payload) {
      var params = {
        endpoint: 'vw-heat',
        action: 'update-heat-tower-config',
        ...payload,
      }
      try {
        const { data } = await axios.post('/api-map.php', params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
      }
    },
    async deleteCloudTowerConfig ({ state, commit, dispatch }, payload) {
      var params = {
        endpoint: 'vw-heat',
        action: 'delete-heat-tower-config',
        ...payload,
      }
      try {
        const { data } = await axios.post('/api-map.php', params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        // commit('SELECT_APPT_OPTS', []);
      }
    },

    // Cloud Tower Config Members
    async getCloudTowerConfigMembers ({ state, commit, dispatch }, payload) {
      try {
        const { data } = await axios.get('/api-map.php?endpoint=vw-heat&action=get-heat-tower-config-members&rowkey=' + payload)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async getCloudTowerConfigMembersByTower ({ state, commit, dispatch }, payload) {
      try {
        const { data } = await axios.get('/api-map.php?endpoint=vw-heat&action=get-heat-tower-config-members-by-tower&rowkey=' + payload)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async createCloudTowerConfigMember ({ state, commit, dispatch }, payload) {
      var params = {
        endpoint: 'vw-heat',
        action: 'create-heat-tower-config-membership',
      }
      params.tower_rowkey = payload.tower_rowkey
      params.config_rowkey = payload.config_rowkey

      try {
        const { data } = await axios.post('/api-map.php', params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
      }
    },
    async deleteCloudTowerConfigMember ({ state, commit, dispatch }, payload) {
      var params = {
        endpoint: 'vw-heat',
        action: 'delete-heat-tower-config-membership',
      }
      params.rowkey = payload.rowkey
      try {
        const { data } = await axios.post('/api-map.php', params)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
      }
    },

  },
  getters: {
    cloudTowers: state => state.cloudTowers,
    cloudTowerPreviews: state => state.cloudTowerPreviews,
    cloudTowerConfigs: state => state.cloudTowerConfigs,
    cloudTowerConfigMemberships: state => state.cloudTowerConfigs,
    towerHeights: state => state.towerHeights,
    smHeights: state => state.smHeights,
  },
  plugins: [persist.plugin],
}
